import styled from "styled-components";
import { media } from "../../utils/styles/media";
import { colors } from './../../utils/styles/colors';

export const InfluencersContainer = styled.div`
    
    padding: 50px;
    .goBack{
        display: flex;
        .backIcon{
            margin-right: 10px;
        }
    }
    .influencersBody{
        display: flex;
        .menu{
            width: 20%;
            //max-height: 250px;
            position: sticky;
            top: 10px;
        }
        .menuMobile{
            display: none;
        }
        .influencersContent{
            width: 80%;
            .results{
                display: flex;
                justify-content: space-between;
                align-items: center;
                
                font-size: 1.1rem;
                .totalResults{
                    font-weight: 600;
                }
            }
            .cards{
                display: flex;
                justify-content: flex-start;
                flex-wrap: wrap;
                padding-top: 10px;
            }
            .noResults{
                min-height: 80%;
                display: flex;
                align-items: center;
                justify-content: center;
            }
            .seeMore{
                margin-top: 20px;
                text-align: center;
                font-weight: 700;
                font-size: 1.4rem;
                color: ${colors.hightlight};
                text-decoration: underline;
                cursor: pointer;
            }
        }
        
    }

    /**-------------Responsive--------------- */
    ${media.desktop}{

    }

    ${media.laptop}{
        padding: 30px;
        .influencersBody{
            display: flex;
            width: 100%;
            .menu{
                width: 28%;
            }
            .influencersContent{
                width:80%;
                padding-left: 2px;
                .results{
                    .totalResults{
                        font-size: 1rem;
                    }
                }
                .seeMore{
                    font-size: 1.2rem;
                }
            }
        }
    }

    ${media.largeMobile}{
        padding: 20px;
        .influencersBody{
            flex-direction: column;
            .menu{
                display: none;
            }
            
            .influencersContent{
                width: 100%;
                .cards{
                    justify-content: space-between;
                }
                .noResults{
                    min-height: 50vh;
                }
                .seeMore{
                    font-size: 1.1rem;
                }
                
            }
        }
    }



`